import { Collection } from 'modules/core/lib/mobx-rest'

import HiddenTeam from 'modules/company_page/store/models/HiddenTeam'

class HiddenTeams extends Collection<HiddenTeam> {
  get cacheKey(): string {
    return 'hiddenTeams'
  }

  model() {
    return HiddenTeam
  }
}

export { HiddenTeams }
